import { styled } from "goober";
import { AskMonitoringChat } from "./AskMonitoringChat";
import { formatBytes } from "../../lib/formatBytes";
import { routes, useMakeUrl } from "../../lib/urls";
import { useMonitoringInteraction } from "./analytics";
import { ButtonLink } from "../Button/ButtonLink";
import { Text } from "../Text";
import { Treemap } from "../Treemap";
import { OTHER_SPACES_KEY } from "./spaceSegments";
import { storageUsageLevel } from "./storageUsageLevel";
import { useStorageUsage } from "./useStorageUsage";
import { Panel, PanelHeader, PanelSkeleton, TotalRow } from "./workflowsLayout";

const Header = styled("div")`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
`;

export function StorageUsageBySpace() {
  const makeUrl = useMakeUrl();
  const recordInteraction = useMonitoringInteraction();
  const { loading, rows, spaceTile } = useStorageUsage();

  if (loading) {
    return <PanelSkeleton />;
  }

  // The modal’s top level, so a tile here opens the same space there.
  const level = storageUsageLevel(rows, [], spaceTile);
  const urlFor = (path: string) => makeUrl(routes.modal.storageUsage, { path });

  return (
    <Panel>
      <Header>
        <PanelHeader>
          <Text variant="text-small-md">Storage by space</Text>
          <TotalRow>
            <Text variant="display-md">{formatBytes(level.totalBytes)}</Text>
          </TotalRow>
        </PanelHeader>
        <ButtonLink
          variant="subtle"
          size="m"
          icon="list-tree"
          to={urlFor("")}
          aria-label="Open storage breakdown"
          onClick={() =>
            recordInteraction("workflows.storage_usage_drill", {
              targetType: "storage",
            })
          }
        >
          Browse
        </ButtonLink>
      </Header>

      <Treemap
        segments={level.segments}
        placeholder={level.segments.length === 0}
        formatValue={formatBytes}
        segmentUrl={(segment) =>
          urlFor(segment.key === OTHER_SPACES_KEY ? "" : segment.key)
        }
        onSegmentNavigate={(segment) =>
          recordInteraction("workflows.storage_usage_drill", {
            targetType: "space",
            targetId: segment.key,
          })
        }
      />
      <AskMonitoringChat
        surface="storage"
        label="Explore in Chat"
        snapshot={`${formatBytes(level.totalBytes)} currently used`}
      />
    </Panel>
  );
}
